import { c as _c } from "react/compiler-runtime";
interface FileAttachmentProps {
  fileName: string;
  url: string;
  fileSize?: number;
}
function formatFileSize(bytes?: number): string {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
export default function FileAttachment(t0) {
  const $ = _c(20);
  const {
    fileName,
    url,
    fileSize
  } = t0;
  let t1;
  if ($[0] !== fileName) {
    t1 = fileName?.split(".").pop()?.toUpperCase() || "FILE";
    $[0] = fileName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ext = t1;
  let t2;
  if ($[2] !== ext) {
    t2 = <div className="w-12 h-12 bg-012061 rounded flex items-center justify-center flex-shrink-0"><span className="text-white font-bold text-12-english-700">{ext}</span></div>;
    $[2] = ext;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fileName) {
    t3 = <div className="text-16-tamil-500 text-1B1B1B truncate">{fileName}</div>;
    $[4] = fileName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fileSize) {
    t4 = fileSize ? <div className="text-12-tamil-400" style={{
      color: "#00000099"
    }}>{formatFileSize(fileSize)}</div> : null;
    $[6] = fileSize;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="min-w-0">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="flex items-center space-x-3 min-w-0">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== fileName || $[15] !== url) {
    t7 = <a href={url} download={fileName} target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-012061 text-white rounded hover:opacity-90 transition-opacity text-14-tamil-500 flex-shrink-0">பதிவிறக்க</a>;
    $[14] = fileName;
    $[15] = url;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="border border-DCDCDC rounded-lg p-4 bg-gray-50 flex items-center justify-between gap-3">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}